import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import { kebabCase } from 'lodash';

export default function BlogListItem ({ node }) {
  return (
    <article className="post" key={node.fields.slug}>
      {node.frontmatter.img &&
        node.frontmatter.img.childImageSharp &&
        node.frontmatter.img.childImageSharp.fluid && (
          <Link
            title={node.frontmatter.title}
            aria-label={`abrir o post "${node.frontmatter.title}"`}
            to={node.fields.slug}
            className="post-thumbnail"
          >
            <Img
              className="post-thumbnail-child"
              fluid={node.frontmatter.img.childImageSharp.fluid}
              onClick={() => alert('CLICK')}
            />
          </Link>
        )}
      <div className="post-content">
        <h2 className="post-title">
          <Link
            to={node.fields.slug}
            aria-label="Abrir o post"
          >
            {node.frontmatter.title}
          </Link>
        </h2>
        <p>{node.excerpt}</p>
        <span className="post-date">
          {node.frontmatter.date}&nbsp;&nbsp;—&nbsp;
        </span>
        <span className="post-words">
          {node.timeToRead} minuto{node.timeToRead > 1 ? 's' : ''} de leitura
        </span>
    
        <span>  </span>
    
        <span className="page-tag-blog-list">
          {node.frontmatter.tags &&
            node.frontmatter.tags.map(tag => (
              <span key={tag}>
                <Link
                  title={`Ver Todos os Posts com a Tag "${tag}"`}
                  aria-label={`ver posts com a tag ${tag}`}
                  className="tag"
                  to={`/tags/${kebabCase(tag)}/`}
                >
                  #{tag}
                </Link>
              </span>
            ))}
        </span>
      </div>
    </article>
  )
}